define((require) => {
    "use strict";

    const Backbone       = require("backbone");
    const AnimationModel = require("shared/ui/experience/widgets/animations/AnimationModel");

    /**
     * A collection of animations.
     *
     * @class AnimationCollection
     * @constructor
     */
    return Backbone.Collection.extend({
        model: AnimationModel
    });
});



// WEBPACK FOOTER //
// ./src/shared/ui/experience/widgets/animations/AnimationCollection.js